import { ca } from '@cian/analytics';

import { EDeviceType } from '../../../types/device';
import { IBrokerAnalyticsUser } from '../../../types/newbuildingBroker';
import { toSiteType } from '../../../utils/trackings';

export const trackSellApartmentClick = (user: IBrokerAnalyticsUser, deviceType: EDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: 'Button',
    page: {
      pageType: 'ListingFavorites',
      siteType: toSiteType(deviceType),
    },
    user,
    useLastProducts: true,
  });
};
